import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a651ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-[8px] tw-px-[13px] tw-py-[10px] tw-h-[34px] tablet" }
const _hoisted_2 = { class: "tw-w-[max-content] tw-flex" }
const _hoisted_3 = {
  key: 0,
  class: "tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[500] tw-leading-[130%]"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-cursor-pointer tw-absolute tw-w-[200%] tw-h-[100%]" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7",
  height: "8",
  viewBox: "0 0 7 8",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "6.22217",
    y: "0.499985",
    width: "1.09989",
    height: "8.79912",
    transform: "rotate(45 6.22217 0.499985)",
    fill: "#B7B7B7"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    y: "1.2782",
    width: "1.09989",
    height: "8.79912",
    transform: "rotate(-45 0 1.2782)",
    fill: "#B7B7B7"
  })
], -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  __name: 'tabletView',
  props: {
  parentTitle: {
    type: String,
    required: false,
    default: "",
  },
  childTitle: {
    type: String,
    required: true,
    default: "nnn",
  },
},
  emits: ["close"],
  setup(__props, { emit: emits }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      (__props.parentTitle)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.parentTitle) + ":" + _toDisplayString(" "), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(`tw-text-[#231F20] tw-text-[11px] tw-not-italic ${
          __props.parentTitle ? 'tw-font-[400]' : 'tw-font-[500]'
        } tw-leading-[130%]`)
      }, _toDisplayString(__props.childTitle), 3)
    ]),
    _createElementVNode("span", {
      class: "tw-cursor-pointer tw-relative",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }, _hoisted_6)
  ]))
}
}

})